import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

const ProductsContext = React.createContext();

export const ProductsProvider = ({ children }) => {
  // Buat state yang diperlukan untuk menampung data fetching

  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const [product, setProduct] = useState(null);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products`
      );
      setProducts(response.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

//   const fetchProducts = async () => {
//   const url = `${process.env.REACT_APP_API_URL}/api/products`;
//   console.log("🧪 Fetching from:", url);
//   setLoading(true);
//   try {
//     const response = await axios.get(url);
//     console.log("✅ Products fetched:", response.data.data);
//     setProducts(response.data.data);
//   } catch (err) {
//     console.log("❌ Error fetching products:", err);
//   } finally {
//     setLoading(false);
//   }
// };

  const getProductById = async (id) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products/${id}`
      );
      setProduct(response.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllCategory = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/categories`
      );
      setCategory(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchProducts();
    getAllCategory();
  }, []);

  console.log("products", products);
  return (
    <ProductsContext.Provider
      value={{ products, loading, getProductById, product, category }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

// make sure use
export const useProductsContext = () => {
  return useContext(ProductsContext);
};
